// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GiftOutlinedSvg from "@ant-design/icons-svg/es/asn/GiftOutlined";
import AntdIcon from '../components/AntdIcon';

var GiftOutlined = function GiftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GiftOutlinedSvg
  }));
};

GiftOutlined.displayName = 'GiftOutlined';
export default React.forwardRef(GiftOutlined);